import { create } from "zustand";
import { useNotepadStore } from "./useNotepadStore";

export const CANVAS_INACTIVITY_TIMEOUT_S = 45;  // 45 seconds
export const WARNING_DURATION_S = 5;            // countdown shown in toast

interface NotepadInactivityStore {
  isWarning: boolean;
  countdown: number;

  _inactivityTimer: ReturnType<typeof setTimeout> | null;
  _countdownInterval: ReturnType<typeof setInterval> | null;

  start: () => void;
  stop: () => void;
  reset: () => void;
  keepOpen: () => void;
  _triggerWarning: () => void;
  _clearAll: () => void;
}

export const useNotepadInactivityStore = create<NotepadInactivityStore>((set, get) => ({
  isWarning: false,
  countdown: WARNING_DURATION_S,
  _inactivityTimer: null,
  _countdownInterval: null,

  _clearAll: () => {
    const { _inactivityTimer, _countdownInterval } = get();
    if (_inactivityTimer) clearTimeout(_inactivityTimer);
    if (_countdownInterval) clearInterval(_countdownInterval);
    set({ _inactivityTimer: null, _countdownInterval: null });
  },

  _triggerWarning: () => {
    get()._clearAll();
    set({ isWarning: true, countdown: WARNING_DURATION_S });

    const interval = setInterval(() => {
      const { countdown } = get();
      if (countdown <= 1) {
        get()._clearAll();
        set({ isWarning: false, countdown: WARNING_DURATION_S });
        useNotepadStore.getState().close();
      } else {
        set({ countdown: countdown - 1 });
      }
    }, 1000);

    set({ _countdownInterval: interval });
  },

  start: () => {
    if (useNotepadStore.getState().ingressType !== "student") return;
    get()._clearAll();
    set({ isWarning: false, countdown: WARNING_DURATION_S });

    const timer = setTimeout(() => {
      get()._triggerWarning();
    }, CANVAS_INACTIVITY_TIMEOUT_S * 1000);

    set({ _inactivityTimer: timer });
  },

  stop: () => {
    get()._clearAll();
    set({ isWarning: false, countdown: WARNING_DURATION_S });
  },

  reset: () => {
    if (get().isWarning) return;
    if (useNotepadStore.getState().ingressType !== "student") return;
    get()._clearAll();
    get().start();
  },

  keepOpen: () => {
    get()._clearAll();
    set({ isWarning: false, countdown: WARNING_DURATION_S });
    get().start();
  },
}));
